// SignIn — Google sign-in entry for workers. Triggered by AdminGate when
// no Firebase user is present yet.

import { signInGoogle } from "@goodbye/firebase";
import {
  Hairline,
  Han,
  HUD,
  MonoLabel,
  T,
  TextBtn,
} from "@goodbye/ui";
import { useState } from "react";

export interface SignInProps {
  /** "not-worker" rejection message when applicable */
  rejectedEmail?: string | null;
}

export function SignIn({ rejectedEmail }: SignInProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function go() {
    setBusy(true);
    setError(null);
    try {
      await signInGoogle();
      // onAuthStateChanged in AdminGate flips state, no nav needed.
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        background: T.paper,
      }}
    >
      <HUD label="工 作 端" />
      <div
        style={{
          flex: 1,
          padding: "0 32px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 24,
        }}
      >
        <Han size={22} color={T.ink900}>工作員登入</Han>
        <MonoLabel size={12} color={T.ink500}>
          僅 @lifesolutions.org.tw 信箱可進
        </MonoLabel>
        <Hairline />

        {rejectedEmail && (
          <Han size={12} color={T.ink900}>
            · 已拒絕 {rejectedEmail} · 不在工作員名單
          </Han>
        )}
        {error && (
          <Han size={12} color={T.ink900}>· {error}</Han>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <TextBtn onClick={go} disabled={busy}>
            {busy ? "· 登 入 中…" : "· 用 Google 登 入"}
          </TextBtn>
        </div>
      </div>
    </div>
  );
}
